/**
 * wql
 * @description 学分   科目管理
 * @Date  2020/10/20
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';

import { component_tool, framework_tool } from '../../../../tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;


class SubjectList extends WizContainer {
  componentName = 'subjectPathList';
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _exportTrainPathInfo(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let headList = o.data['headList']
      let dataList = o.data['dataList']
      WizBrowserExport({
        title: '路径信息',
        sheetName: '路径信息',
        columns: handleExportHeader(headList).filter((_, index) => index),
        rows: dataList,
        filename: '路径信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPathContent(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let title = o.data.title
      let dataList = o.data['dataList']
      let headList = o.data['headList']
      WizBrowserExport({
        title: title,
        sheetName: '路径内容',
        columns: handleExportHeader(headList).filter((_, index) => index),
        rows: dataList,
        filename: '路径内容.xlsx',
      })

      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }



  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        enable: this._handleCMD,
        exportTrainPathInfo: this._exportTrainPathInfo,
        getPathContent:this._getPathContent,
        updateState: this._handleCMD,
        del: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(SubjectList);
